import { render, staticRenderFns } from "./ClassTrainingResourceEdit.vue?vue&type=template&id=6cf0a83b&scoped=true"
import script from "./ClassTrainingResourceEdit.vue?vue&type=script&lang=js"
export * from "./ClassTrainingResourceEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf0a83b",
  null
  
)

export default component.exports